import React from 'react';
import './WalletCard.scss';

const WalletCard = ({ children, className }) => {
    return <div className={`wallet-card ${className}`}>{children}</div>;
};
export default WalletCard;
